export default __webpack_public_path__ + "static/media/KindBaum.e7eb260d.JPG";